var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBihFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_49545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00292969 0H59.9971V45H0.00292969V0Z",
    fill: "#000099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4658 0L57.3779 45.0264V0.0263672L12.4658 0Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1631 42.3193L43.7109 40.5352L41.1973 42.3106L42.1465 39.3926L39.668 37.5908H42.7441L43.6934 34.6729L44.6338 37.5996H47.71L45.249 39.4189L46.1631 42.3193ZM53.3086 43.2334L50.2324 43.2246L49.292 40.2979L48.3428 43.2158H45.2666L47.7451 45.0176L46.7959 47.9356L49.3096 46.1602L51.7705 47.9443L50.8477 45.0439L53.3086 43.2334ZM39.6328 33.8115L42.0938 31.9922L39.0176 31.9834L38.0771 29.0654L37.1279 31.9834L34.0518 31.9746L36.5303 33.7764L35.5811 36.7031L38.0947 34.9189L40.5557 36.7119L39.6328 33.8115ZM33.9814 28.1426L36.4424 26.332L33.3662 26.3232L32.4258 23.3965L31.4678 26.3145H28.4004L30.8789 28.1162L29.9297 31.0342L32.4434 29.2588L34.8955 31.043L33.9814 28.1426ZM28.3828 22.5527L30.8438 20.7334H27.7676L26.8359 17.7979L25.8867 20.7158H22.8105L25.2891 22.5088L24.3398 25.4356L26.8535 23.6514L29.3145 25.4443L28.3916 22.5439L28.3828 22.5527ZM22.7227 16.9014L25.1836 15.0908L22.1074 15.082L21.167 12.1553L20.209 15.0732H17.1416L19.6289 16.875L18.6797 19.793L21.1934 18.0176L23.6455 19.8018L22.7314 16.9014H22.7227ZM17.1328 11.2852L19.585 9.46582H16.5088L15.5771 6.53027L14.6191 9.45703H11.543L14.0391 11.25L13.0811 14.168L15.5947 12.3926L18.0381 14.1855L17.1328 11.2852ZM11.5078 5.66016L13.96 3.84082H10.8838L9.95215 0.905273L8.99414 3.83203H5.91797L8.41406 5.625L7.44727 8.55176L9.96973 6.76758L12.4131 8.56055L11.5078 5.66016ZM5.88281 0.0351567L8.32617 -1.78418H5.25L4.30957 -4.71094L3.36914 -1.79297H0.292969L2.78027 0L1.83105 2.91797L4.34473 1.14258L6.78809 2.93555L5.88281 0.0351567Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_49545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBihFlag);
export default __webpack_public_path__ + "static/media/bih-flag.c862b20f564ec808d8fc15b66597294c.svg";
export { ForwardRef as ReactComponent };